import { useCallback, useMemo, useState } from 'react';
import { config as configCore } from '@industriousapps/excelkits-core';
import featureFlags from '@/config/features';
const SUPPORT_GOOGLE_PICKER = featureFlags.googlePicker; // const SUPPORT_SHARED_WORKBOOKS_SELECT = featureFlags.sharedWorkbooksSelect;

const SUPPORTED_FILE_TYPES = configCore.spreadsheets.supportedFileTypes;
const ACCEPTED_FILE_EXTS = SUPPORTED_FILE_TYPES.slice(0, 9).join(', ');
export let DataSource;

(function (DataSource) {
  DataSource["LOCAL_FILE"] = "LOCAL_FILE";
  DataSource["GOOGLE_DRIVE"] = "GOOGLE_DRIVE";
  DataSource["TEAM_WORKBOOKS"] = "TEAM_WORKBOOKS";
  DataSource["SHARED_WORKBOOKS"] = "SHARED_WORKBOOKS";
  DataSource["UNSYNC"] = "UNSYNC";
})(DataSource || (DataSource = {}));

const dataSourceOptions = [{
  value: DataSource.LOCAL_FILE,
  label: 'Upload Local File',
  description: `Supports: ${ACCEPTED_FILE_EXTS} and more.`,
  icon: '/icons/spreadsheets-circle.svg',
  enabled: true
}, {
  value: DataSource.GOOGLE_DRIVE,
  label: 'Connect Google Drive',
  description: 'Upload a file from Google drive, with the option to sync live updates to widgets.',
  icon: '/icons/logos/google-drive.svg',
  enabled: SUPPORT_GOOGLE_PICKER
}, {
  value: DataSource.TEAM_WORKBOOKS,
  label: 'Team Workbooks',
  description: 'Select an existing workbook from your team’s local workspace.',
  icon: '/icons/team-circle.svg',
  requireAuth: true,
  enabled: true
}, {
  value: DataSource.SHARED_WORKBOOKS,
  label: 'Shared Workbooks',
  description: 'Explore our database of free, shared, workbooks you can copy and customize.',
  icon: '/icons/globe-circle.svg' // enabled: SUPPORT_SHARED_WORKBOOKS_SELECT,

}];
export const unsyncSourceOptions = [{
  value: DataSource.UNSYNC,
  label: 'Unsync Workbook',
  description: 'Before modifying any data, unsync this workbook from Google Drive.',
  icon: '/icons/disconnect-circle.svg',
  enabled: true
}]; // Get a list of data sources that can be selected
// based on the current user's authentication status
// and enabled features.

export default function useDataSourceSelect(_ref) {
  let {
    isLoggedIn,
    defaultValue
  } = _ref;
  const {
    0: dataSource,
    1: setDataSource
  } = useState(defaultValue || null);
  const options = useMemo(() => dataSourceOptions.filter(option => {
    // Filter out options that are not enabled or require authentication
    // when the user is not logged in.
    // Also filter out the current data source.
    const isAuthorized = !option.requireAuth || isLoggedIn;
    const isSelected = dataSource === option.value;
    return !isSelected && isAuthorized && option.enabled;
  }), [dataSource, isLoggedIn]);
  const handleSelect = useCallback(value => {
    setDataSource(value);
  }, []);
  const handleDeselect = useCallback(() => {
    setDataSource(null);
  }, []);
  return {
    dataSource,
    options,
    handleSelect,
    handleDeselect
  };
}